<div>

  <div *ngFor="let message of messages" class="alert alert-{{message.type}} alert-dismissible fade show" role="alert">
    <strong>{{message.code}}</strong> {{message.message}}
    <button (click)="removeMsg(message.id)" type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
  </div>

</div>
